module.exports = __webpack_public_path__ + "img/text.2532253f.png";